import { Injectable } from '@angular/core';
import {
    CatalogDuplicateSku,
    CatalogDuplicateSkuItem,
    CatalogMismatch,
    CatalogMismatchSkuItem,
    SquareCatalogItem,
} from '../store/square-catalog-item.models';

@Injectable({
    providedIn: 'root',
})
export class AdapterService {
    adaptAll(items: any[]): SquareCatalogItem[] {
        return items.map((item) => this.adaptSingle(item));
    }

    adaptSingle(item: any): SquareCatalogItem {
        const newItem = {
            ...item,
            squareId: item.square_item_id,
        };

        const { square_item_id, ...rest } = newItem;
        return rest;
    }

    adaptMismatch(raw: any): CatalogMismatch | null {
        if (!raw) return null;

        const squareSkusNotInMasterCatalog: CatalogMismatchSkuItem[] = (
            raw.square_skus_not_in_master_catalog ?? []
        ).map((entry: any) => ({
            sku: entry.sku,
            itemName: entry.item_name,
        }));

        const squareDuplicateSkusInCatalog: CatalogDuplicateSku[] = (
            raw.square_duplicate_skus_in_catalog ?? []
        ).map((entry: any) => {
            const items: CatalogDuplicateSkuItem[] = (entry.items ?? []).map(
                (i: any) => ({
                    squareItemId: i.square_item_id,
                    itemName: i.item_name,
                })
            );
            return {
                sku: entry.sku,
                occurrences: entry.occurrences,
                items,
            };
        });

        return {
            hasMismatch: raw.has_mismatch ?? false,
            squareSkusNotInMasterCatalog,
            totalSquareSkus: raw.total_square_skus ?? 0,
            totalMatchedSkus: raw.total_matched_skus ?? 0,
            totalMismatchSkus: raw.total_mismatch_skus ?? 0,
            hasDuplicateSkusInSquare: raw.has_duplicate_skus_in_square ?? false,
            squareDuplicateSkusInCatalog,
            totalDuplicateSkus: raw.total_duplicate_skus ?? 0,
        };
    }
}
